import apiClient from '../../../../shared/infrastructure/api/client';
import { ChatMessage, ChatHistoryResponse } from '../../domain/PatientChat';

export const PatientChatHistoryApiService = {
  load: async (patientId: string): Promise<ChatMessage[]> => {
    const res = await apiClient.get<ChatHistoryResponse>(`/patients/${patientId}/chat-history`);
    return res.data.messages;
  },

  save: async (patientId: string, messages: ChatMessage[]): Promise<void> => {
    await apiClient.put(`/patients/${patientId}/chat-history`, { messages });
  },
};
